'use strict'

import Vue from 'vue'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

import App from './App.vue'
import router from './router'
import store from './store'

import '../public/assets/css/site.css'

const debugKey = 'showdebug'
const debuggerStr = `..${debugKey}..`

if (window.location.search.toLowerCase().indexOf(debuggerStr) > -1) {
  Vue.config.devtools = true
}

Vue.config.productionTip = false

// Dynamic title updates
router.beforeEach((to, from, next) => {
  const main = 'Garage Rats Car Club'
  document.title = (to.meta.title) 
    ? `${to.meta.title} | ${main}`
    : main
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
